import { Component, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { PopoverModule } from 'primeng/popover';
import { User } from 'src/app/models/User';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';
import { environment } from 'src/environments/environment';
import { UserProfileViewComponent } from './user-profile-view/user-profile-view.component';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  standalone: true,
  imports: [
    SHARED_IMPORTS,
    AvatarModule,
    PopoverModule,
    UserProfileViewComponent
  ]
})
export class UserAvatarComponent {
  @Input({ required: true }) user!: User;

  get userAvatarUrl(): string {
    const baseUrl = environment.apiUrl;

    return `${baseUrl}/users/avatar/${this.user.id}`;
  }

  get userAvatarLabel(): string {
    return `${this.user.firstname?.charAt(0).toUpperCase()}${this.user.lastname?.charAt(0).toUpperCase()}`;
  }

  get hasAvatar(): boolean {
    return Boolean(this.user.profilePictureId);
  }
}
